import React, { useCallback, useEffect, useRef, useState } from "react";
import "./styles.css";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import { AgGridReact } from "ag-grid-react";
import DeleteIcon from "../../../../../../../../../../assets/images/deleteIcon.svg";
import InfoIcon from "../../../../../../../../../../assets/images/infoIcon.svg";
import PlusButtonIcon from "../../../../../../../../../../assets/images/PlusButtonIcon.svg";
import CustomStatusFilter from "../../../../../../../../../../components/Grid/components/CustomStatusFilter";
import Status from "../../../../../../../../../../components/Grid/components/Status";
import { RowSelection } from "../../../../../../../../../../components/Grid/model/Grid";
import ModalDelete from "../../../../../../../../../../components/ModalDelete";
import Loading from "../../../../../../../../../../core/common/Loading";
import {
  formatDateTimeBR,
  renderPaymentTypes,
} from "../../../../../../../../../../helpers/format";
import { STATUS_PAGAMENTO } from "../../../../../../../../../../helpers/status";
import { useStatus } from "../../../../../../../../../../hooks/StatusContext";
import { useAuth } from "../../../../../../../../../../hooks/AuthenticateContext";
import api from "../../../../../../../../../../services/api";
import Info from "./components/Info";
import ReversedPayment from "./components/ReversedPayment";
import { usePaykit } from "../../../../../../../../../../hooks/PaykitContext";

const ListPayment = () => {
  const [columns, setColumns] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [selectedRow, setSelectedRow] = useState();
  const [isView, setIsView] = useState(false);
  const [isRemove, setIsRemove] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [currentRow, setCurrentRow] = useState();
  const [isReversedPayment, setIsReversedPayment] = useState(false);

  const defaultColumns = [
    {
      field: "data_hora_pagamento",
      headerName: "Data do pagamento",
      valueFormatter: (params) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }

        return "---";
      },
    },
    {
      field: "tipo_pagamento",
      headerName: "Tipo de pagamento",
      valueFormatter: (params) => {
        if (params.value) {
          return renderPaymentTypes(params.value);
        }

        return "---";
      },
    },
    {
      field: "tempo_base_triagem",
      headerName: "Tempo base Triagem",
    },
    {
      field: "quantia_paga",
      headerName: "Valor Pago",
      valueFormatter: (params) => {
        if (params.value) {
          return `R$ ${params.value}`;
        }

        return "---";
      },
    },
    {
      field: "",
      headerName: "",
      pinned: "right",
      cellRenderer: (params) => {
        if (params.data) {
          return (
            <div>
              <button
                className="mr-4"
                onClick={() => {
                  // addBreadcrumb("Conhecer");
                  // props.onView(params.data);
                  setSelectedRow(params.data);
                  setIsView(!isView);
                }}
              >
                <img src={InfoIcon} style={{ width: 16, height: 16 }} />
              </button>
              <button
                onClick={() => {
                  // props.onDelete(params.data);
                  setSelectedRow(params.data);
                  setIsReversedPayment(!isReversedPayment);
                }}
              >
                <img src={DeleteIcon} style={{ width: 16, height: 16 }} />
              </button>
            </div>
          );
        }
      },
    },
  ];

  const authenticatedRef = useRef(false);

  const { setStatus } = useStatus();
  const { user } = useAuth();
  const gridRef = useRef(null);

  const { authenticated, error, reveralPayment } = usePaykit();

  const hasReversedInvoicedPayment = rowData.some((payment) => {
    return Number(payment?.tipo_pagamento) === 3 && Number(payment?.status) === 1;
  });

  const hasActiveInvoicedPayment = rowData.some((payment) => {
    return Number(payment?.tipo_pagamento) === 3 && Number(payment?.status) === 0;
  });

  const hasActivePayment = rowData.some((payment) => {
    return Number(payment?.status) === 0;
  });

  const syncTriagemAfterReversal = useCallback((responseData) => {
    let storedTriagem = localStorage.getItem("@triagem");
    let resolvedStatus = 10;

    if (storedTriagem) {
      storedTriagem = JSON.parse(storedTriagem);
    }

    if (responseData?.status !== undefined && responseData?.status !== null) {
      resolvedStatus = responseData.status;
    }

    const baseTriagem = storedTriagem || currentRow;
    let updatedTriagem = baseTriagem ? { ...baseTriagem } : {};

    if (responseData) {
      updatedTriagem = { ...updatedTriagem, ...responseData };
    }

    if (!baseTriagem && !responseData) {
      updatedTriagem = { status: resolvedStatus };
    }

    if (baseTriagem?.entrada_veiculos && !updatedTriagem.entrada_veiculos) {
      updatedTriagem.entrada_veiculos = baseTriagem.entrada_veiculos;
    }

    if (
      baseTriagem?.operacao_porto_agendada &&
      !updatedTriagem.operacao_porto_agendada
    ) {
      updatedTriagem.operacao_porto_agendada =
        baseTriagem.operacao_porto_agendada;
    }

    if (
      baseTriagem?.operacao_porto_carrossel &&
      !updatedTriagem.operacao_porto_carrossel
    ) {
      updatedTriagem.operacao_porto_carrossel =
        baseTriagem.operacao_porto_carrossel;
    }

    updatedTriagem.status =
      updatedTriagem.status !== undefined && updatedTriagem.status !== null
        ? updatedTriagem.status
        : resolvedStatus;

    localStorage.setItem("@triagem", JSON.stringify(updatedTriagem));
    setCurrentRow(updatedTriagem);
  }, [currentRow]);

  const refreshPaymentList = useCallback(() => {
    const api = gridRef.current?.api || gridRef.current || gridApi;

    if (!api) return;

    if (typeof api.purgeInfiniteCache === "function") {
      api.purgeInfiniteCache();
      return;
    }

    if (typeof api.refreshInfiniteCache === "function") {
      api.refreshInfiniteCache();
    }
  }, [gridApi]);


  const onGridReady = useCallback(async (params) => {
    try {
      console.log("entrou");
      let cols = defaultColumns;

      cols.unshift({
        field: "status",
        fieldName: "status",
        headerName: "Status",
        filter: CustomStatusFilter,
        filterParams: {
          status: STATUS_PAGAMENTO,
        },
        // width: 310,
        cellStyle: { textAlign: "center" },
        // pinned: "left",
        cellRenderer: (params) => {
          if (params.data) {
            return (
              <Status data={STATUS_PAGAMENTO} status={params.data.status} />
            );
          }
        },
      });

      setColumns(cols);

      console.log(cols);

      setGridApi(params.api);
    } catch { }
  }, []);

  const onDelete = useCallback(async (rowId, justificativaEstorno) => {
    try {
      setLoading(true);

      const userId = user?.id;

      const body = {
        id_operacao_patio_pagamento: rowId,
        id_usuario_historico: userId,
        justificativa_estorno: justificativaEstorno,
      };

      console.log("Passou", body);

      const response = await api.post("/operacaopatio/estorno", body);

      if (response.status === 200) {
        syncTriagemAfterReversal(response.data);
      }

      setLoading(false);

      setIsRemove(false);

      refreshPaymentList();
    } catch {
      setLoading(false);
    }
  }, [refreshPaymentList, syncTriagemAfterReversal, user?.id]);

  var checkouts;
  var checkout;
  var authSuccessMessage = 'Autenticado com sucesso.';

  var onPaymentSuccess = function (response, row, justificativaEstorno) {
    console.log(response.receipt.merchantReceipt + '<br>' + response.receipt.customerReceipt);
    console.log(response);

    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;


    const printWindow = window.open('', '', `width=${screenWidth},height=${screenHeight},top=0,left=0`);
    printWindow.document.write(`<!DOCTYPE html>
    <html lang="pt-BR">
      <head>
        <meta charset="UTF-8">
        <title></title> <!-- Deixe o título vazio -->
        <style>
          body {
            font-family: monospace;
            white-space: pre;
            font-size: 14px;
            margin: 0;
            padding: 20px;
          }

          @media print {
            @page {
              margin: 0;
            }
            body {
              margin: 0;
              padding: 2px;
            }
          }
        </style>
      </head>
      <body>
        <pre>${response.receipt.merchantReceipt}</pre>
      </body>
    </html>`);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();

    onDelete(row.id_operacao_patio_pagamento, justificativaEstorno);
  };
  var onPaymentError = function (error) {
    console.log(error);
    console.log('Código: ' + error.reasonCode + '<br>' + error.reason);

    if (error.reasonCode == 9) {
      checkout = window.PaykitCheckout.undoPayments();
    }
  };

  const creditPayment = (value) => {
    var creditRequest = {
      amount: parseFloat(value),
      requestKey: null,
    };

    if (window.PaykitCheckout) {
      checkout = window.PaykitCheckout.creditPayment(creditRequest, onPaymentSuccess, onPaymentError);
    } else {
      FrontendNotification("Erro ao carregar o SDK Paykit", "error")
    }

  }


  function debitPayment(value) {
    console.log(value);
    const amount = parseFloat(value);
    if (window.PaykitCheckout) {
      checkout = window.PaykitCheckout.debitPayment({ amount: amount }, onPaymentSuccess, onPaymentError);
    } else {
      FrontendNotification("Erro ao carregar o SDK Paykit", "error")
    }
  }


  const onPayment = useCallback(async (row, justificativaEstorno) => {
    try {
      const amount = row.quantia_paga;

      console.log(row);
      // Check if this payment method requires Linx SDK for reversal
      if (row.administrative_code !== null) {

        const request = {
          administrativeCode: row.administrative_code !== null ? row.administrative_code : '',
          amount: String(amount),
          data: '010925'
        };

        if (authenticated) {
          reveralPayment(request, (response) => onPaymentSuccess(response, row, justificativaEstorno), (error) => onPaymentError(error))
        }

      } else {
        // For non-card payments, delete directly
        onDelete(row.id_operacao_patio_pagamento, justificativaEstorno);
        // Clear the payment in progress since we're handling it directly
        setPaymentInProgress(null);
      }
    } catch (error) {
      console.error('Payment reversal error:', error);
      // Clear the payment in progress on error
      setPaymentInProgress(null);
    }
  }, [authenticated, onDelete, reveralPayment]);


  useEffect(() => {

    if (gridApi) {
      const dataSource = {
        getRows: async (params) => {
          try {
            // Fazer uma requisição ao servidor passando os parâmetros da página
            const page = params.endRow / 100 - 1;

            let currentRow = localStorage.getItem("@triagem");

            if (currentRow) {
              currentRow = JSON.parse(currentRow);
            }

            setCurrentRow(currentRow);

            const id_operacao_patio =
              localStorage.getItem("id_operacao_patio") ||
              currentRow.id_operacao_patio;

            const body = {
              id_operacao_patio: Number(id_operacao_patio),
              qtd_por_pagina: 100,
              order_by: "data_historico",
              order_direction: "desc",
            };

            const response = await api.post(
              `/operacaopatio/pagamentos?page=${page + 1}`,
              body
            );

            params.successCallback(response.data.data, response.data.total);
            setRowData(response.data.data);
          } catch { }
        },
      };

      gridApi.setDatasource(dataSource);
    }
  }, [gridApi]);

  return (
    <div className="overflow-y-scroll w-auto max-h-[calc(80vh)] p-3">
      <Loading loading={loading} skeletonVariant="grid" skeletonRows={6} skeletonColumns={6} skeletonFooterButtons={0} />

      {isReversedPayment && (
        <ReversedPayment
          onConfirm={({ justificativa }) => {
            setIsReversedPayment(false);
            onPayment(selectedRow, justificativa)
          }}
          onCancel={() => setIsReversedPayment(!isReversedPayment)}
        />
      )}

      {isRemove && (
        <ModalDelete
          title="Deseja estornar o pagamento?"
          message="Por favor, confirme que você deseja estornar o seguinte registro:"
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => setIsReversedPayment(true)}
          row={selectedRow?.id_operacao_patio_pagamento}
        />
      )}
      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Pagamentos"
          onClose={() => setIsView(!isView)}
        />
      )}
      {currentRow && currentRow.status < 11 && (
        <div className="w-full h-full flex justify-end">
          <button
            className="flex items-center justify-center h-10 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
            onClick={() => setStatus(hasReversedInvoicedPayment && !hasActiveInvoicedPayment && !hasActivePayment ? 2 : 3)}
          >
            Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
          </button>
        </div>
      )}
      <div className="ag-theme-quartz h-96 mt-4">
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columns}
          rowModelType="infinite"
          pagination
          rowSelection={RowSelection.SINGLE}
          enableCellTextSelection={true}

          onGridReady={onGridReady}
        />
      </div>
    </div>
  );
};

export default ListPayment;